import { useState } from "react";
import { client } from '../apiClient';
import { listVets } from '../graphql/queries';
import { Typeahead, withAsync } from 'react-bootstrap-typeahead';

import {
    View,
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
const AsyncTypeahead = withAsync(Typeahead);


export default function VetSearch( props) {

    const [items, setItems] = useState([]);
    const [lastquery, setLastQuery] = useState('');
    const [isSearching, setIsSearching] = useState(false);



    async function searchVets(query) {
        // Require a minimum query length so we never fire the unbounded list fetch.
        if (!query || query.trim().length < 3) {
            setItems([]);
            return [];
        }
        let vets = [];
        setIsSearching(true);
        try {
            let filter = { name_lc: { contains: query?.toLowerCase() } }
            let response = await client.graphql({ query: listVets, variables: { filter: filter, limit: 3000 } });
            vets = response?.data?.listVets?.items || [];
            setLastQuery(query);
            setItems(vets);
        } catch (error) {
            console.error('VetSearch failed:', JSON.stringify(error));
            // Surface an empty state rather than crashing on an unhandled rejection.
            setItems([]);
        } finally {
            setIsSearching(false);
        }
        return vets;
    }


    return (
        <View columnSpan={{ base: 2, large: 2 }}>
            <AsyncTypeahead style={{ margin: 0 }}
                id="get-quote-typeahead"
                onChange={props?.onChange}
                isLoading={isSearching}
                minLength={3}
                onSearch={(query) => searchVets(query)}
                options={items}
                useCache={true}
                promptText={'Type in 3 characters of Vet'}
                emptyLabel={'No matching Vet'}
                defaultInputValue={props?.defaultInputValue ? props?.defaultInputValue: lastquery}
                disabled={props?.isDisabled}
                ignoreDiacritics={true}
                flip={true}
                labelKey={'name'}
                //size={'lg'}
                //autoFocus={true}
                autoComplete="off"
                
            />
        </View>
    );

}

